import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxButtonModule } from '../button/phx-button.module';
import { PhxDropdownModule } from '../dropdown/phx-dropdown.module';
import { PhxMenuButtonComponent } from './phx-menu-button.component';


@NgModule({
  declarations: [
    PhxMenuButtonComponent
  ],
  imports: [
    CommonModule,
    PhxButtonModule,
    PhxDropdownModule,
  ],
  exports: [
    PhxMenuButtonComponent
  ]
})
export class PhxMenuButtonModule { }
